<template>
  <div class="celan">
    <!-- 隐藏侧栏的三角形 -->
    <span :class="flag?'yincangsanjiao1':'yincangsanjiao2'" @click="yccl"></span>
    <!-- 侧栏 -->
    <el-aside v-show="flag" width="200px" style="background: #e6e6e6;">
      <el-menu :default-openeds="['', '']" style="background: #e6e6e6;">
          <el-submenu index="1">
            <template slot="title"><i class="el-icon-tickets"></i>订单总览</template>
            <el-menu-item-group>
              <el-menu-item index="1-1">
                <router-link to='/'>订单总览</router-link>
              </el-menu-item>
              <el-menu-item index="1-2">
                <router-link to='/successpay'>订单记录</router-link>
              </el-menu-item>
            </el-menu-item-group>
          </el-submenu>
          <el-submenu index="2">
            <template slot="title"><i class="el-icon-message"></i> 收 款 码</template>
            <el-menu-item-group>
              <el-menu-item index="2-1">
                <router-link to='/upimg'>上传收款码</router-link>
              </el-menu-item>
              <el-menu-item index="2-2">
                <router-link to='/imglist'>收款码列表</router-link>
              </el-menu-item>
            </el-menu-item-group>
          </el-submenu>
<!--           <el-submenu index="3">
            <template slot="title"><i class="el-icon-setting"></i>控制中心</template>
            <el-menu-item-group>
              <el-menu-item index="3-1">
                <router-link to='/kongzhi'>通道控制</router-link>
              </el-menu-item>
            </el-menu-item-group>
          </el-submenu>   -->        
          <el-submenu index="4">
            <template slot="title"><i class="el-icon-info"></i>使用说明</template>
            <el-menu-item-group>
              <el-menu-item index="4-1">
                <router-link to='/faqipay'>发起支付</router-link>
              </el-menu-item>
            </el-menu-item-group>
          </el-submenu>
      </el-menu>
    </el-aside>  
  </div>
</template>

<script>

export default {
  name: 'celan',
  data(){
     return{
        flag:''
     }
  },
  mounted(){
     if(sessionStorage.getItem("flag")==null){
        sessionStorage.setItem("flag",'1');
        this.flag=Number(sessionStorage.getItem("flag"));
     }else{
        this.flag=Number(sessionStorage.getItem("flag"));
     };
  },
  methods: {
     //隐藏侧栏
     yccl(){
        // this.flag=!this.flag
        var flags=Number(sessionStorage.getItem("flag"));
        if (flags==0) {
           sessionStorage.setItem("flag",'1');
           this.flag=Number(sessionStorage.getItem("flag"));
        };
        if (flags==1) {
           sessionStorage.setItem("flag",'0');
           this.flag=Number(sessionStorage.getItem("flag"));
           //刷新页面
           // location.reload();
        };
     }
  }
}

</script>


<style scoped>
.celan {
    background: #e6e6e6;
}
.yincangsanjiao1{
    position: absolute;
    left: 132px;
    top: 19px;
    z-index: 99999;
    width: 0;
    height: 0;
    border: 11px solid transparent;
    border-left-color: #333333;
    position: absolute;
    content: '';
    cursor: pointer;
}
.yincangsanjiao2{
    position: absolute;
    left: 132px;
    top: 19px;
    z-index: 99999;
    width: 0;
    height: 0;
    border: 11px solid transparent;
    border-right-color: #333333;
    position: absolute;
    content: '';
    cursor: pointer;
}
@media screen and (max-width: 800px) {
  .yincangsanjiao1{
    left: 132px;
    top: -42px;
  }  
  .yincangsanjiao2{
    left: 132px;
    top: -42px;
  }
  .celan {
    position: absolute;
    z-index: 999;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/celan.vue